import * as theme from "../../theme";
import Button from "react-bootstrap/Button";
import { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import EditIconOutlined from "@material-ui/icons/CreateOutlined";
import Modal from "react-modal";
import CancelIcon from "@material-ui/icons/Cancel";
import PerfectScrollbar from "react-perfect-scrollbar";
import Select from "react-select";
import { toast } from "react-toastify";
import { tr } from "date-fns/locale";
import {
  paymentProviderModalOpened,
  getPaymentModalOpen,
  paymentProviderModalClosed,
  addNewPaymentProvider,
  getAllPaymentProvider,
  getPaymentProviders,
  updatePaymentProvider,
  getUpdateProvider,
  paymentProviderNull,
  getIsAddedProvider,
  getAddUpdateResp,
} from "../../store/paymentprovider";
import broker, { getBrokerInformation } from "../../store/broker";
import translations from "../../utils/translations";
import { CheckBox } from "@material-ui/icons";
import { autofill } from "redux-form";
import { keyframes } from "styled-components";
// Helper function for French-friendly labels
const getLocalizedLabel = (label, language = "en") => {
  if (!label) return "";
  if (typeof label === "string") return label; // Backward compatibility
  return label[language] || label.en || label;
};

const PaymentProvider = () => {
  return <PaymentProviderPane></PaymentProviderPane>;
};

const PaymentProviderPane = () => {
  const dispatch = useDispatch();
  const paymentProviders = useSelector(getPaymentProviders);
  const isAddedProvider = useSelector(getIsAddedProvider);
  const addUpdateResp = useSelector(getAddUpdateResp);
  const brokerInfo = useSelector(getBrokerInformation);
  const languagepreference = brokerInfo?.information?.languagepreference || "en";

  useEffect(async () => {
    await dispatch(getAllPaymentProvider());
  }, []);
  useEffect(() => {
    if (isAddedProvider === true) {
      toast.success(addUpdateResp.message);
    }
  }, [addUpdateResp.message]);

  const onPaymentProviderModelChangeHandle = () => {
    dispatch(paymentProviderModalOpened());
  };

  const onUpdatePaymentProviderModelChangeHandle = async (provider) => {
    await dispatch(updatePaymentProvider(provider));
    await dispatch(paymentProviderModalOpened());
  };

  return (
    <div className="m-4">
      <div className="d-flex">
        <div
          className="m-4"
          style={{
            width: "100%",
          }}
        >
          <div
            className="d-flex"
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: "1.2vw",
            }}
          >
            {translations[languagepreference].paymentProvider.description}
          </div>

          <div
            className="d-flex m-2"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              paddingTop: "25px",
              fontSize: "0.8vw",
            }}
          >
            <table className="table  table-sm">
              <thead>
                <tr>
                  <th scope="col">{translations[languagepreference].paymentProvider.providerName}</th>
                  <th scope="col ">{translations[languagepreference].paymentProvider.action}</th>
                </tr>
              </thead>
              <tbody>
                {paymentProviders &&
                  paymentProviders?.map((provider, index) => {
                    return (
                      <tr scope="row" className="thead-light">
                        <th scope="row">{provider.provider}</th>
                        <th scope="row" className="d-flex">
                          <div
                            className="text-center"
                            style={{
                              backgroundColor: theme.COLORS.secondary_orange,
                              width: "30px",
                              height: "30px",
                              padding: 4,
                              borderRadius: 16,
                              color: "white",
                              cursor: "pointer",
                            }}
                          >
                            <EditIconOutlined
                              text="Update"
                              fontSize="small"
                              onClick={() =>
                                onUpdatePaymentProviderModelChangeHandle(
                                  provider
                                )
                              }
                            />
                          </div>
                        </th>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_orange,
                border: 5,
                marginLeft: "10px",
              }}
              onClick={onPaymentProviderModelChangeHandle}
            >
              {translations[languagepreference].paymentProvider.addProvider}
            </Button>
          </div>
        </div>
      </div>
      <PaymentModal></PaymentModal>
    </div>
  );
};

const PaymentModal = (props) => {
  const newProviderModalState = useSelector(getPaymentModalOpen);
  return (
    <Modal
      size="md"
      isOpen={newProviderModalState}
      ariaHideApp={false}
      shouldCloseOnEsc={false}
      centered
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: "40rem",
          width: "50rem",
          position: "absolute",
          top: "8vh",
          left: "20vw",
          background: "#eef3f6",
          WebkitOverflowScrolling: "touch",
          border: "8px solid " + theme.COLORS.primary_navyblue,
          borderRadius: "20px",
          padding: 0,
          overflow: "hidden",
        },
      }}
    >
      <ProviderModalPage></ProviderModalPage>
    </Modal>
  );
};

const ProviderModalPage = (props) => {
  const dispatch = useDispatch();
  const brokerInfo = useSelector(getBrokerInformation);
  const languagepreference = brokerInfo?.information?.languagepreference || "en";
  const [paymentProviderName, setPaymentProviderName] = useState("");
  const [providerNameError, setProviderNameError] = useState("");
  const [premium, setPremium] = useState(false);
  const [insurerFees, setInsurerFees] = useState(false);
  const [brokerFees, setBrokerFees] = useState(false);
  const [taxRate, setTaxRate] = useState(false);
  const [taxAmount, setTexAmount] = useState(false);
  const [totalAmount, setTotalAmount] = useState(false);
  const [keyList, setKeyList] = useState([{ key: "", label: "", keyType: "" }]);

  const [keyListErrors, setKeyListErrors] = useState([]);
  const [isList, setIsList] = useState(false);
  const [taxAmountForm, setTaxAmountForm] = useState("");
  const [totalAmountForm, setTotalAmountForm] = useState("");
  const [listValues, setListValues] = useState(keyList.map(() => []));
  const [newListValue, setNewListValue] = useState("");
  const [keyType, setKeyType] = useState([]);
  const [selectedObjects, setSelectedObjects] = useState([]);

  const checkboxes = [
    {
      key: "premium",
      label: {
        en: translations.en.paymentProvider.premium,
        fr: translations.fr.paymentProvider.premium
      },
      keyType: "Number",
      formula: "",
    },
    {
      key: "insurerFees",
      label: {
        en: translations.en.paymentProvider.insurerFees,
        fr: translations.fr.paymentProvider.insurerFees
      },
      keyType: "Number",
      formula: "",
    },
    {
      key: "brokerFee",
      label: {
        en: translations.en.paymentProvider.brokerFee,
        fr: translations.fr.paymentProvider.brokerFee
      },
      keyType: "Number",
      formula: "",
    },
    {
      key: "taxRate",
      label: {
        en: translations.en.paymentProvider.taxRate,
        fr: translations.fr.paymentProvider.taxRate
      },
      keyType: "Percentage",
      formula: "",
    },
    {
      key: "taxAmount",
      label: {
        en: translations.en.paymentProvider.taxAmount,
        fr: translations.fr.paymentProvider.taxAmount
      },
      keyType: "Number",
      formula: "(premium+insurerFees+brokerFee) * (taxRate/100)",
    },
    {
      key: "totalAmount",
      label: {
        en: translations.en.paymentProvider.totalAmountFinanced,
        fr: translations.fr.paymentProvider.totalAmountFinanced
      },
      keyType: "Number",
      formula: "(premium+insurerFees+brokerFee)+taxAmount",
    },
  ];

  useEffect(() => {
    setSelectedObjects(checkboxes);
  }, []);
  // Initialize an empty array to store the selected objects
  function handleCheckboxSelection(key, isChecked) {
    const checkbox = checkboxes.find((checkbox) => checkbox.key === key);

    if (checkbox) {
      if (isChecked) {
        const selectedObjectIndex = selectedObjects.findIndex(
          (obj) => obj.key === key
        );

        if (selectedObjectIndex === -1) {
          const newObject = {
            key: key,
            label: checkbox.label, // Keep the full multilingual object
            keyType: checkbox.keyType,
          };
          setSelectedObjects((prevSelectedObjects) => [
            ...prevSelectedObjects,
            newObject,
          ]);
        }
      } else {
        setSelectedObjects((prevSelectedObjects) =>
          prevSelectedObjects.filter((obj) => obj.key !== key)
        );
      }

      // Check if any of the checkboxes that add taxAmount and totalAmount are selected
      const hasTaxAmountCheckbox = selectedObjects.some(
        (obj) =>
          obj.key === "premium" ||
          obj.key === "insurerFees" ||
          obj.key === "brokerFee" ||
          obj.key === "taxRate"
      );

      const taxAmountCheckbox = checkboxes.find((cb) => cb.key === "taxAmount");
      if (
        hasTaxAmountCheckbox &&
        !selectedObjects.some((obj) => obj.key === "taxAmount")
      ) {
        const taxAmountObject = {
          key: taxAmountCheckbox.key,
          label: taxAmountCheckbox.label,
          keyType: taxAmountCheckbox.keyType,
          formula: taxAmountCheckbox.formula,
        };
        setSelectedObjects((prevSelectedObjects) => [
          ...prevSelectedObjects,
          taxAmountObject,
        ]);
      }

      // Find the totalAmount object in the checkboxes array and update it in selectedObjects if necessary
      const totalAmountCheckbox = checkboxes.find(
        (cb) => cb.key === "totalAmount"
      );
      if (
        hasTaxAmountCheckbox &&
        !selectedObjects.some((obj) => obj.key === "totalAmount")
      ) {
        const totalAmountObject = {
          key: totalAmountCheckbox.key,
          label: totalAmountCheckbox.label,
          keyType: totalAmountCheckbox.keyType,
          formula: totalAmountCheckbox.formula,
        };
        setSelectedObjects((prevSelectedObjects) => [
          ...prevSelectedObjects,
          totalAmountObject,
        ]);
      }

      updateFormulas(key);
    }
  }

  // Function to update the taxAmount and totalAmount formulas based on the selected objects
  function updateFormulas(keyString) {
    // Check if the premium checkbox is selected
    const premiumCheckbox = checkboxes.find(
      (checkbox) => checkbox.key === "premium"
    );
    const isPremiumSelected = selectedObjects.some(
      (obj) => obj.key === "premium"
    );

    // Check if the insurerFees checkbox is selected
    const insurerFeesCheckbox = checkboxes.find(
      (checkbox) => checkbox.key === "insurerFees"
    );
    const isInsurerFeesSelected = selectedObjects.some(
      (obj) => obj.key === "insurerFees"
    );

    // Check if the brokerFee checkbox is selected
    const brokerFeeCheckbox = checkboxes.find(
      (checkbox) => checkbox.key === "brokerFee"
    );
    const isBrokerFeeSelected = selectedObjects.some(
      (obj) => obj.key === "brokerFee"
    );

    // Find the taxAmount object in the selectedObjects array and update its formula
    const taxAmountObject = selectedObjects.find(
      (obj) => obj.key === "taxAmount"
    );
    if (taxAmountObject) {
      const taxAmountFormula = `(${
        isPremiumSelected ? premiumCheckbox.key : 0
      }${isInsurerFeesSelected ? "+" + insurerFeesCheckbox.key : ""}${
        isBrokerFeeSelected ? "+" + brokerFeeCheckbox.key : ""
      }) * (taxRate/100)`;

      const updatedTaxAmountObject = {
        ...taxAmountObject,
        formula: taxAmountFormula,
      };

      setSelectedObjects((prevSelectedObjects) =>
        prevSelectedObjects.map((obj) =>
          obj.key === "taxAmount" ? updatedTaxAmountObject : obj
        )
      );
      document.getElementById("taxAmountFormulaLabel").textContent =
        taxAmountFormula;
    }

    // Find the totalAmount object in the selectedObjects array and update its formula
    const totalAmountObject = selectedObjects.find(
      (obj) => obj.key === "totalAmount"
    );
    if (totalAmountObject) {
      const totalAmountFormula = `(${
        isPremiumSelected ? premiumCheckbox.key : 0
      }${isInsurerFeesSelected ? "+" + insurerFeesCheckbox.key : ""}${
        isBrokerFeeSelected ? "+" + brokerFeeCheckbox.key : ""
      }) + taxAmount`;

      // totalAmountObject.formula = totalAmountFormula;
      const updatedTotalAmountObject = {
        ...totalAmountObject,
        formula: totalAmountFormula,
      };

      setSelectedObjects((prevSelectedObjects) =>
        prevSelectedObjects.map((obj) =>
          obj.key === "totalAmount" ? updatedTotalAmountObject : obj
        )
      );
      document.getElementById("totalAmountFormulaLabel").textContent =
        totalAmountFormula; // Set formula label in the UI
    }

    // Iterate through selectedObjects and evaluate the formulas
    selectedObjects.forEach((obj) => {
      if (obj.formula) {
        const formula = obj.formula.replace(/(\w+)/g, (match) => {
          const variableObject = selectedObjects.find(
            (obj) => obj.key === match
          );
          return variableObject ? variableObject.value : match;
        });
        obj.value = eval(formula);
      }
    });
  }

  const getPaymentprovider = useSelector(getUpdateProvider);

  useEffect(() => {
    setPaymentProviderName(getPaymentprovider?.provider);
    setKeyList(
      getPaymentprovider?.keylist || [{ key: "", label: "", keyType: "" }]
    );

    const initialListValues =
      getPaymentprovider?.keylist?.map((item) => item.listValues) || [];
    setListValues(initialListValues);
  }, []);

  const handleCodeChange = (index, field, value) => {
    const updatedCodes = [...keyList];

    if (field === 'label' && typeof value === 'object') {
      // Handle multilingual label object
      const currentLabel = updatedCodes[index].label || {};
      const newLabel = { ...currentLabel, ...value };

      // Auto-populate French with English if French is empty and English is being updated
      if (value.en && (!newLabel.fr || newLabel.fr === (currentLabel.en || ""))) {
        newLabel.fr = value.en;
      }

      updatedCodes[index] = { ...updatedCodes[index], [field]: newLabel };
    } else {
      // Handle other fields and backward compatibility
      updatedCodes[index] = { ...updatedCodes[index], [field]: value };
    }

    setKeyList(updatedCodes);

    const updatedErrors = [...keyListErrors];
    updatedErrors[index] = { ...updatedErrors[index], [`${field}Error`]: "" };
    setKeyListErrors(updatedErrors);
  };

  const onAddButtonClick = async (e) => {
    e.preventDefault();

    if (paymentProviderName === "" || paymentProviderName === undefined) {
      setProviderNameError(translations[languagepreference].paymentProvider.fieldRequired);
      return;
    }

    const updatedErrors = keyList.map((code) => {
      // Check if label is empty (handle both string and object formats)
      let labelEmpty = false;
      if (!code.label) {
        labelEmpty = true;
      } else if (typeof code.label === 'string') {
        labelEmpty = code.label === "";
      } else if (typeof code.label === 'object') {
        labelEmpty = (!code.label.en || code.label.en === "") && (!code.label.fr || code.label.fr === "");
      }

      return {
        keyNameError:
          code.key === "" || code.key === undefined
            ? translations[languagepreference].paymentProvider.fieldRequired
            : "",
        valueError: labelEmpty
          ? translations[languagepreference].paymentProvider.fieldRequired
          : "",
      };
    });

    setKeyListErrors(updatedErrors);

    if (
      updatedErrors.some(
        (error) => error.keyNameError !== "" || error.valueError !== ""
      )
    ) {
      return;
    }

    const updatedKeyList = keyList.map((code, index) => ({
      ...code,
      listValues: listValues[index] || [],
    }));

    const paymentProvider = {
      paymentProvider: {
        provider: paymentProviderName,
        keyList: updatedKeyList,
        formula: selectedObjects,
      },
    };

    const updatePaymentProvider = {
      paymentProvider: {
        _id: getPaymentprovider._id,
        provider: paymentProviderName,
        keyList: updatedKeyList,
        formula: selectedObjects,
      },
    };

    dispatch(
      addNewPaymentProvider(
        getPaymentprovider._id ? updatePaymentProvider : paymentProvider
      )
    ).then(async () => {
      await dispatch(paymentProviderNull());
      await dispatch(getAllPaymentProvider());
      await dispatch(paymentProviderModalClosed());
    });
  };

  const handleAddCodeField = () => {
    setIsList(false);
    const newCode = { key: "", label: "", keyType: "" };
    setKeyList([...keyList, newCode]);
    setListValues([...listValues, []]);
    setNewListValue("");
  };

  const handleRemoveCodeField = (index) => {
    const updatedCodes = [...keyList];
    updatedCodes.splice(index, 1);
    setKeyList(updatedCodes);

    const updatedErrors = [...keyListErrors];
    updatedErrors.splice(index, 1);
    setKeyListErrors(updatedErrors);

    const updatedListValues = [...listValues];
    updatedListValues.splice(index, 1);
    setListValues(updatedListValues);

    const updatedKeyTypes = [...keyType];
    updatedKeyTypes.splice(index, 1);
    setKeyType(updatedKeyTypes);
  };

  const PaymentType = [
    { value: "list", label: translations[languagepreference].paymentProvider.list },
    { value: "number", label: translations[languagepreference].paymentProvider.number },
    { value: "text", label: translations[languagepreference].paymentProvider.text },
    { value: "date", label: translations[languagepreference].paymentProvider.date },
  ];
  const customStyles = {
    control: (provided) => ({
      ...provided,
      color: "red",
      borderWidth: "2px",
      borderColor: "rgb(73, 168, 214)",
      "&:hover": {
        borderColor: "rgb(73, 168, 214)",
      },
    }),
    option: (provided) => ({
      ...provided,
      color: "rgb(63, 68, 90)",
    }),
  };

  const paymentTypeHandler = (e, index) => {
    if (e.label === translations[languagepreference].paymentProvider.list) {
      setIsList(true);
    } else {
      setIsList(false);
    }
    if (e.label) {
      const updatedKeyList = [...keyList];
      updatedKeyList[index] = {
        ...updatedKeyList[index],
        keyType: e.label,
      };
      setKeyList(updatedKeyList);
    }
  };

  return (
    <PerfectScrollbar>
      <div className="container-fluid" style={{ backgroundColor: "#eef3f6" }}>
        <div className="row ml-1 p-3">
          <div
            className="text-center"
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: "24px",
            }}
          >
            {!getPaymentprovider._id
              ? translations[languagepreference].paymentProvider.addProvider
              : translations[languagepreference].paymentProvider.updateProvider}
          </div>

          <div
            className="ml-auto"
            style={{ marginTop: "-15px", marginRight: "-10px" }}
          >
            <CancelIcon
              fontSize="large"
              style={{ cursor: "pointer" }}
              onClick={() => {
                dispatch(paymentProviderModalClosed());
                dispatch(paymentProviderNull());
              }}
            ></CancelIcon>
          </div>
        </div>

        <div
          className="row pt-3  justify-content-center"
          style={{
            fontFamily: "GibsonRegular",
          }}
        >
          <div className="col-10">
            <form noValidate>
              <CommonInputField
                type={"text"}
                name={"providerName"}
                label={translations[languagepreference].paymentProvider.providerName}
                placeholder={translations[languagepreference].paymentProvider.providerName}
                onChange={(event) => {
                  setProviderNameError("");
                  setPaymentProviderName(event.target.value);
                }}
                value={paymentProviderName || ""}
                error={providerNameError}
              ></CommonInputField>
              <CommonInputCheckBoxField
                name={"premium"}
                label={getLocalizedLabel(checkboxes.find(cb => cb.key === "premium")?.label, languagepreference)}
                onChange={(event) => {
                  handleCheckboxSelection("premium", event.target.checked);
                }}
                checked={true}
                disabled={"disabled"}
              ></CommonInputCheckBoxField>
              <CommonInputCheckBoxField
                name={"insurerfees"}
                label={getLocalizedLabel(checkboxes.find(cb => cb.key === "insurerFees")?.label, languagepreference)}
                onChange={(event) => {
                  handleCheckboxSelection("insurerFees", event.target.checked);
                }}
                checked={true}
                disabled={"disabled"}
              ></CommonInputCheckBoxField>
              <CommonInputCheckBoxField
                name={"brokerfees"}
                label={getLocalizedLabel(checkboxes.find(cb => cb.key === "brokerFee")?.label, languagepreference)}
                onChange={(event) => {
                  handleCheckboxSelection("brokerFee", event.target.checked);
                }}
                checked={true}
                disabled={"disabled"}
              ></CommonInputCheckBoxField>
              <CommonInputCheckBoxField
                name={"taxRate"}
                label={getLocalizedLabel(checkboxes.find(cb => cb.key === "taxRate")?.label, languagepreference)}
                onChange={(event) => {
                  handleCheckboxSelection("taxRate", event.target.checked);
                }}
                checked={true}
                disabled={"disabled"}
              ></CommonInputCheckBoxField>
              <CommonInputCheckBoxField
                name={"taxAmount"}
                label={getLocalizedLabel(checkboxes.find(cb => cb.key === "taxAmount")?.label, languagepreference)}
                checked={true}
                disabled={"disabled"}
                // data="taxAmountFormulaLabel"
                labelDisplay={"(premium+insurerFees+brokerFee) * (taxRate/100)"}
              ></CommonInputCheckBoxField>
              <CommonInputCheckBoxField
                name={"totalAmount"}
                label={getLocalizedLabel(checkboxes.find(cb => cb.key === "totalAmount")?.label, languagepreference)}
                disabled={"disabled"}
                checked={true}
                // data="totalAmountFormulaLabel"
                labelDisplay={"(premium+insurerFees+brokerFee)+taxAmount"}
              ></CommonInputCheckBoxField>

              {keyList &&
                keyList.map((code, index) => (
                  <div
                    className="card mb-3 "
                    style={{ backgroundColor: "#e9ecef" }}
                    key={index}
                  >
                    <div className="card-body">
                      <div className="form-group row">
                        <div className="col-sm-4">
                          <label
                            className="col-form-label"
                            style={{
                              fontWeight: "bold",
                              fontSize: "16px",
                              color: theme.COLORS.grey_font_header,
                            }}
                          >
                            {translations[languagepreference].paymentProvider.key}
                          </label>
                        </div>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            className="form-control"
                            placeholder={translations[languagepreference].paymentProvider.enterKey}
                            required
                            style={{
                              color: theme.COLORS.dark_navy_blue,
                              border: `2px solid ${theme.COLORS.secondary_skyblue}`,
                              borderRadius: 5,
                              letterSpacing: 1.2,
                              backgroundColor:
                                theme.COLORS.tertiary_ligthindigo,
                            }}
                            onChange={(event) =>
                              handleCodeChange(index, "key", event.target.value)
                            }
                            value={code.key || ""}
                          />
                          {keyListErrors[index]?.keyNameError && (
                            <p style={{ color: "red" }}>
                              {keyListErrors[index]?.keyNameError}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontWeight: "bold",
                              fontSize: "16px",
                              color: theme.COLORS.grey_font_header,
                            }}
                            className="col-form-label"
                          >
                            {translations[languagepreference].paymentProvider.value}
                          </label>
                        </div>
                        <div className="col-sm-8">
                          <div style={{ marginBottom: "10px" }}>
                            <label style={{ fontWeight: "bold", fontSize: "14px", marginBottom: "5px", display: "block" }}>
                              {languagepreference === "fr" ? "Étiquette anglaise:" : "English Label:"}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder={languagepreference === "fr" ? "Entrez l'étiquette anglaise" : "Enter English label"}
                              required
                              style={{
                                color: theme.COLORS.dark_navy_blue,
                                border: `2px solid ${theme.COLORS.secondary_skyblue}`,
                                borderRadius: 5,
                                letterSpacing: 1.2,
                                backgroundColor: theme.COLORS.tertiary_ligthindigo,
                              }}
                              onChange={(event) =>
                                handleCodeChange(index, "label", {
                                  ...(typeof code.label === 'object' ? code.label : {}),
                                  en: event.target.value
                                })
                              }
                              value={
                                typeof code.label === 'object'
                                  ? code.label.en || ""
                                  : code.label || ""
                              }
                            />
                          </div>

                          <div style={{ marginBottom: "10px" }}>
                            <label style={{ fontWeight: "bold", fontSize: "14px", marginBottom: "5px", display: "block" }}>
                              {languagepreference === "fr" ? "Étiquette française:" : "French Label:"}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder={languagepreference === "fr" ? "Entrez l'étiquette française" : "Enter French label"}
                              required
                              style={{
                                color: theme.COLORS.dark_navy_blue,
                                border: `2px solid ${theme.COLORS.secondary_skyblue}`,
                                borderRadius: 5,
                                letterSpacing: 1.2,
                                backgroundColor: theme.COLORS.tertiary_ligthindigo,
                              }}
                              onChange={(event) =>
                                handleCodeChange(index, "label", {
                                  ...(typeof code.label === 'object' ? code.label : {}),
                                  fr: event.target.value
                                })
                              }
                              value={
                                typeof code.label === 'object'
                                  ? code.label.fr || code.label.en || ""
                                  : code.label || ""
                              }
                            />
                          </div>

                          {keyListErrors[index]?.valueError && (
                            <p style={{ color: "red" }}>
                              {keyListErrors[index]?.valueError}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="form-group row ">
                        <label
                          className="col-sm-4 col-form-label "
                          style={{
                            fontWeight: "bold",
                            fontSize: "16px",
                            color: theme.COLORS.grey_font_header,
                          }}
                        >
                          {translations[languagepreference].paymentProvider.type}
                        </label>
                        <div className="col-sm-8">
                          <Select
                            className="form-select"
                            placeholder={translations[languagepreference].paymentProvider.selectOption}
                            styles={customStyles}
                            onChange={(e) => {
                              paymentTypeHandler(e, index);
                            }}
                            value={[
                              {
                                label: keyList[index]?.keyType,
                                value: keyList[index]?.keyType,
                              },
                            ]}
                            // value={keyList[index]?.keyType}
                            options={PaymentType}
                            style={{
                              width: "100%",
                              height: "6vh",
                              fontSize: "1.9vmin",
                              border: "5px solid white",
                              borderRadius: 15,
                              fontFamily: "GibsonRegular",
                            }}
                          />
                        </div>
                      </div>
                      {keyList[index]?.keyType === translations[languagepreference].paymentProvider.list && (
                        <div className="form-group row">
                          <label
                            className="col-sm-4 col-form-label"
                            style={{
                              fontWeight: "bold",
                              fontSize: "16px",
                              color: theme.COLORS.grey_font_header,
                            }}
                          >
                            {translations[languagepreference].paymentProvider.listValue}
                          </label>
                          <div className="col-sm-8">
                            <div style={{ marginBottom: "8px" }}>
                              <small
                                style={{
                                  fontSize: "12px",
                                  fontStyle: "italic",
                                  color: theme.COLORS.grey_font,
                                }}
                              >
                                {translations[languagepreference].paymentProvider.commaInstructions}
                              </small>
                            </div>
                            <textarea
                              type="text"
                              id={`list_${index}`}
                              name={`list_${index}`}
                              rows="3"
                              className="form-control"
                              placeholder={translations[languagepreference].paymentProvider.enterListValue}
                              style={{
                                color: theme.COLORS.dark_navy_blue,
                                border: `2px solid ${theme.COLORS.secondary_skyblue}`,
                                borderRadius: 5,
                                letterSpacing: 1.2,
                                backgroundColor:
                                  theme.COLORS.tertiary_ligthindigo,
                              }}
                              value={listValues[index]?.join(",")}
                              onChange={(e) => {
                                const updatedListValues = [...listValues];
                                updatedListValues[index] =
                                  e.target.value.split(",");
                                setListValues(updatedListValues);
                              }}
                            />
                          </div>
                        </div>
                      )}

                      {index > 0 && (
                        <button
                          type="button"
                          className="btn btn-primary btn-md"
                          style={{
                            color: "white",
                            fontFamily: "GibsonSemiBd",
                            fontSize: 12,
                            backgroundColor: "#d81e30",
                          }}
                          onClick={() => handleRemoveCodeField(index)}
                        >
                          {translations[languagepreference].paymentProvider.delete}
                        </button>
                      )}
                    </div>
                  </div>
                ))}

              <div className="form-group row">
                <div className="col-sm-4"></div>
                <div className="col-sm-8">
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{
                      color: "white",
                      fontFamily: "GibsonSemiBd",
                      fontSize: 12,
                      backgroundColor: theme.COLORS.secondary_skyblue,
                    }}
                    onClick={handleAddCodeField}
                  >
                    {translations[languagepreference].paymentProvider.addKeyName}
                  </button>
                </div>
              </div>

              <div
                className="form-group row justify-content-center"
                style={{ paddingTop: "2%" }}
              >
                <div className="col-12">
                  <button
                    type="submit"
                    style={{
                      backgroundColor: theme.COLORS.secondary_orange,
                      borderRadius: "10px",
                    }}
                    className="btn btn-primary btn-block"
                    onClick={onAddButtonClick}
                  >
                    {!getPaymentprovider._id
                      ? translations[languagepreference].paymentProvider.addProvider
                      : translations[languagepreference].paymentProvider.updateProvider}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </PerfectScrollbar>
  );
};

const CommonInputField = ({
  label = "Sample common label",
  onChange,
  value,
  defaultValue,
  placeholder,
  error,
  type,
  name,
}) => {
  return (
    <div className="form-group row">
      <label
        className="col-sm-4 col-form-label"
        style={{
          fontWeight: "bold",
          fontSize: "16px",
          color: theme.COLORS.grey_font_header,
        }}
      >
        {label}
      </label>
      <div className="col-sm-8">
        <input
          autoFocus
          type={type}
          name={name}
          className="form-control"
          placeholder={placeholder}
          required
          style={{
            color: theme.COLORS.dark_navy_blue,
            border: `2px solid ${theme.COLORS.secondary_skyblue}`,
            borderRadius: 5,
            letterSpacing: 1.2,
            backgroundColor: theme.COLORS.tertiary_ligthindigo,
          }}
          value={value}
          onChange={onChange}
        />
        {error && <p style={{ color: "red" }}>{error}</p>}
      </div>
    </div>
  );
};
const CommonInputCheckBoxField = ({
  label = "Sample common label",
  onChange,
  value,
  name,
  checked,
  defaultChecked,
  disabled,
  data,
  labelDisplay,
}) => {
  return (
    <div className="form-group row">
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          style={{
            transform: "scale(2)",
            marginLeft: "0.3px",
          }}
          id={name}
          value={value}
          onChange={onChange}
          checked={checked}
          defaultChecked={defaultChecked}
          disabled={disabled}
        />
      </div>
      <label
        className="ml-5 col-form-label"
        for={name}
        style={{
          fontWeight: "bold",
          marginTop: "-6px",
          fontSize: "16px",
          color: theme.COLORS.grey_font_header,
        }}
      >
        {label}&nbsp;&nbsp; &nbsp;
        <span
          id={data}
          style={{
            color: "grey",
          }}
        >
          {labelDisplay}
        </span>
      </label>
    </div>
  );
};
export default PaymentProvider;
